<template>
	<div>
		<el-form :model="goodsOrder" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="goodsOrder"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="收获电话" prop="telephone">
							<el-input v-model="goodsOrder.telephone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="收获地址" prop="address">
							<el-input v-model="goodsOrder.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="收获人姓名" prop="toName">
							<el-input v-model="goodsOrder.toName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {getGoodsOrder,updateGoodsOrder} from '@/api/api.js'
	import tools from "@/tools"
	import Editor from 'wangeditor'
	import 'wangeditor/release/wangEditor.min.css'
	export default {
		components:{
			Editor
		},
		data(){
			return {
				goodsOrder:{
					id:'',
					telephone:'',
					address:"",
					toName:""
				},
				rules: {
		          telephone: [
		            { required: true, message: '请输入收获电话', trigger: 'blur' }
		          ],
		          address: [
		            { required: true, message: '请输入收获地址', trigger: 'blur' }
		          ],
		          toName: [
		            { required: true, message: '请输入收获人姓名', trigger: 'blur' }
		          ]
		        },
				addLoading:false
			}

		},
		created:function() {
			var id = this.$route.query.id;
			
			if(id){
				getGoodsOrder({id:id}).then(res=>{
					this.goodsOrder = res.data.data;
				});
			};
			
		},
		methods:{
			addSubmit(){
				this.$refs["goodsOrder"].validate((valid)=>{
					this.addLoading=true;
					if(valid){
						updateGoodsOrder(this.goodsOrder).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					};
					this.addLoading=false;	
				});
			},
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>